import { FC } from 'react'
import useFormProcessor from '@hooks/useFormProcessor'
import {
  usePostCourseChapterMutation,
  usePutCourseChapterMutation,
} from '@services/courseChapters'
import { CourseChapterCommonBody } from '@models/courseChapter'
import AddNewItemModal from '@templates/AddNewItemModal'
import getDefaultValues from './getDefaultValues'
import useChapterFormFields from './useChapterFormFields'
import { ChapterFormValues, ChapterFormModalProps } from './types'

const ChapterFormModal: FC<ChapterFormModalProps> = ({
  isEdit = false,
  chapter,
  courseIri,
  handleCloseModal,
}) => {
  const fields = useChapterFormFields()

  const [postCourseChapter, postData] = usePostCourseChapterMutation()
  const [putCourseChapter, putData] = usePutCourseChapterMutation()
  const additionalProps = isEdit ? putData : postData

  const methods = useFormProcessor({
    defaultValues: getDefaultValues(chapter),
    apiErrors: additionalProps.error,
  })

  const handleSubmitForm = (form: ChapterFormValues) => {
    const resultForm: CourseChapterCommonBody = {
      course: courseIri,
      title: form.title,
      hoursCount:
        form.hoursCount != null && form.hoursCount !== ''
          ? Number(form.hoursCount)
          : null,
    }

    if (isEdit) {
      if (chapter) {
        void putCourseChapter({
          ...resultForm,
          id: chapter.id,
        })
      }
    } else {
      void postCourseChapter(resultForm)
    }
  }

  return (
    <AddNewItemModal
      {...additionalProps}
      handleCloseModal={handleCloseModal}
      onSubmitForm={handleSubmitForm}
      methods={methods}
      fields={fields}
      isEdit={isEdit}
      titlePostfix="раздел"
      successContentAddTitle="Вы успешно добавили раздел"
      successContentEditTitle="Вы успешно изменили раздел"
      withSaveAndAddMore
      withStopPropagation
    />
  )
}

export default ChapterFormModal
